import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import { useWorkspaceSignalEditSetBodyMutation } from "./__generated__/useWorkspaceSignalEditSetBodyMutation.graphql";
import { SetStatusFN } from "./statusCoordinator";
import { useDebouncedMutation } from "../../../../../common/Utils/useDebouncedMutation";

const key = "set_body";
export function useSignalEditSetBody(
  id: string,
  remoteBody: {
    body: string;
    formattedBody: string;
  },
  setStatus: SetStatusFN
) {
  const [updateBody, loading] =
    useMutation<useWorkspaceSignalEditSetBodyMutation>(graphql`
      mutation useWorkspaceSignalEditSetBodyMutation(
        $id: ID!
        $body: String!
        $formattedBody: String!
      ) {
        signalWorkspace(id: $id) {
          updateBody(newBody: $body, newFormattedBody: $formattedBody) {
            id
            body
            updatedBySessionId
            formattedBody
            ...WorkspaceSignalEditMainEditedInfo_Signal
          }
        }
      }
    `);

  const saveBody = useCallback(
    (args: { body: string; formattedBody: string }) =>
      updateBody({
        onError: () => setStatus(key, "error"),
        onCompleted: () => setStatus(key, "saved"),
        variables: {
          id,
          body: args.body,
          formattedBody: args.formattedBody,
        },
      }),
    [id, setStatus, updateBody]
  );

  return [
    ...useDebouncedMutation(
      remoteBody,
      saveBody,
      undefined,
      {
        getValueKey: ({ body, formattedBody }) => formattedBody,
      },
      () => setStatus(key, "saving")
    ),
    loading,
  ] as const;
}
